export default "__VITE_ASSET__4579f20f__"